import { call, put, takeEvery } from "redux-saga/effects";
import { getAllTeamMembersApi } from "../../API/API";
import { types } from "../action-types";

const getFirstArray = (payload) => {
  if (Array.isArray(payload)) return payload;

  const arrayKeys = [
    "members",
    "teamMembers",
    "TeamMembers",
    "All",
    "all",
    "data",
    "items",
    "rows",
    "result",
    "results",
  ];

  for (const key of arrayKeys) {
    if (Array.isArray(payload?.[key])) return payload[key];
    if (payload?.[key] && typeof payload[key] === "object") {
      const nested = getFirstArray(payload[key]);
      if (nested.length) return nested;
    }
  }

  return [];
};

const getSafeList = (payload, keys) => {
  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

const getMemberStatus = (member) =>
  String(member?.status || member?.Status || member?.memberStatus || "")
    .trim()
    .toLowerCase();

const splitMembersByStatus = (members) =>
  members.reduce(
    (acc, member) => {
      const status = getMemberStatus(member);
      if (status.includes("pending")) {
        acc.pending.push(member);
      } else if (status.includes("inactive") || status.includes("in-active")) {
        acc.inactive.push(member);
      } else {
        acc.active.push(member);
      }
      return acc;
    },
    { active: [], pending: [], inactive: [] },
  );

const normalizeTeamPagePayload = (payload = {}) => {
  const active = getSafeList(payload, ["Active", "active"]);
  const pending = getSafeList(payload, ["Pending", "pending"]);
  const inactive = getSafeList(payload, ["InActive", "Inactive", "inactive"]);

  const buckets =
    active.length || pending.length || inactive.length
      ? { active, pending, inactive }
      : splitMembersByStatus(getFirstArray(payload));

  return {
    ...buckets,
    totals: {
      active: payload?.totalMembers || payload?.activeCount || buckets.active.length,
      pending:
        payload?.totalPendingCount || payload?.pendingCount || buckets.pending.length,
      inactive:
        payload?.totalInActiveMembers ||
        payload?.inactiveCount ||
        buckets.inactive.length,
    },
  };
};

function* fetchTeamPageSaga(action) {
  try {
    const response = yield call(() => getAllTeamMembersApi({ payload: action.payload || {} }));

    yield put({
      type: types.TEAM_PAGE_FETCH_SUCCESS,
      payload: normalizeTeamPagePayload(response?.data),
    });
  } catch (error) {
    yield put({
      type: types.TEAM_PAGE_FETCH_FAILURE,
      error,
    });
  }
}

export function* watchFetchTeamPageSaga() {
  yield takeEvery(types.TEAM_PAGE_FETCH_REQUESTED, fetchTeamPageSaga);
}
